import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'gender'
})
export class DisplayGenderPipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
  ) { }

  /**
   * example : {{ data.gender | gender | async }}
   * return '25 Years'
   * return '25 ปี'
   */
  transform(value: any, args?: any): any {
    let key = '';
    if (value === 'M') {
      key = 'personal.gender.male';
    } else if (value === 'F') {
      key = 'personal.gender.female';
    }

    return key === '' ? value : this.translate.get(key);
  }

}
